import { defineMessages } from 'react-intl'

const translations = defineMessages({
  shippingAddress: {
    defaultMessage: 'Shipping Address',
    id: 'msp.account.order_history.order_detail.shipping_address'
  },
  billingAddress: {
    defaultMessage: 'Billing Address',
    id: 'msp.account.order_history.order_detail.billing_address'
  },
  paymentMethod: {
    defaultMessage: 'Payment Method',
    id: 'msp.account.order_history.order_detail.payment_method'
  },
  shippingMethod: {
    defaultMessage: 'Shipping Method',
    id: 'msp.account.order_history.order_detail.shipping_method'
  }
})

export default translations
